import type { ComponentType } from 'react';
import { CancelOverlay, DepositOverlay, PaymentOverlay, RefundOverlay, VoidOverlay } from './money';
import { BlockOverlay, ConfirmOverlay, HoldOverlay, LostOverlay, MessageOverlay, PricingOverlay } from './booking';
import { ExpenseOverlay, InvestmentOverlay, VoidExpenseOverlay } from './expense';
import { CheckoutOverlay } from './checkout';
import { NewEnquiry } from './NewEnquiry';
import { EditOverlay } from './edit';

export const OVERLAYS: Record<string, ComponentType<any>> = {
  payment: PaymentOverlay, deposit: DepositOverlay, refund: RefundOverlay, void: VoidOverlay, cancel: CancelOverlay,
  hold: HoldOverlay, confirm: ConfirmOverlay, pricing: PricingOverlay, lost: LostOverlay, message: MessageOverlay, block: BlockOverlay,
  expense: ExpenseOverlay, voidExpense: VoidExpenseOverlay, investment: InvestmentOverlay, checkout: CheckoutOverlay, new: NewEnquiry, edit: EditOverlay,
};
